const reducer = {
  setFieldIDPClients(state, action) {
    const { field, value } = action.payload ?? {};
    if (field) {
      state[field] = value;
    }
  },
  addItemIDPClients(state, action) {
    if (state.list?.length >= 0) {
      state.list.push(action.payload);
    }
  },
  removeItemIDPClients(state, action) {
    state.list.Items = state.list.Items.filter(
      (e) => e.Id !== action.payload?.Id,
    );
  },
};

export default reducer;
